import React__default, { forwardRef, useRef, useEffect, useCallback } from 'react';
import { StyledTextarea, borderWidth } from './StyledTextarea.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const setSmartHeight = el => {
  // Always reset height to auto before calculating new height
  el.style.height = 'auto';
  const borderHeight = borderWidth;
  const paddingBoxHeight = el.scrollHeight;
  const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
  el.style.height = `${borderBoxHeight}px`;
};

// @TODO we're only including this in the main bundle for now to visually test with Storybook
// until we ship a storybook that supports headless @fuegokit/react, @fuegokit/b-r-c,
// @fuegokit/a-r-c, and @fuegokit/m-r-c

// @TODO we'll be deprecating all `Atlas-` components in Q22024 in favor of @fuegokit/a-r-c
const AtlasTextarea = /*#__PURE__*/forwardRef(({
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const {
    resize = 'smart',
    appearance = 'standard',
    isCompact = false,
    isRequired = false,
    isReadOnly = false,
    isDisabled = false,
    isInvalid = false,
    isMonospaced = false,
    minimumRows = 2,
    testId,
    maxHeight = '50vh',
    onBlur,
    onFocus,
    onChange,
    value,
    UNSAFE_className,
    rows: rowsProp
  } = props;

  // Derive rows in case consumers prefer native HTML `rows` prop
  // Prioritize rows over minimumRows if rows is greater,
  // and prioritize minimumRows over rows if minimumRows is greater
  const computedRows = Math.max(rowsProp || 0, minimumRows);
  useEffect(() => {
    const element = innerRef.current;
    if (resize === 'smart' && element) {
      setSmartHeight(element);
    }
  }, [resize, value]);
  const handleOnFocus = event => onFocus && onFocus(event);
  const handleOnBlur = event => onBlur && onBlur(event);
  const handleOnChange = useCallback(event => {
    const element = innerRef.current;
    if (resize === 'smart' && element) {
      setSmartHeight(element);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onChange && onChange(event);
  }, [onChange, resize]);
  return /*#__PURE__*/React__default.createElement(StyledTextarea, _extends({}, props, {
    ref: innerRef,
    appearance: appearance,
    resize: resize,
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    "data-invalid": isInvalid || undefined,
    "data-compact": isCompact || undefined,
    isMonospaced: isMonospaced || undefined,
    testId: testId ? `${testId}-textarea-input` : undefined,
    className: UNSAFE_className || undefined,
    rows: computedRows,
    maxHeight: maxHeight
  }));
});
AtlasTextarea.displayName = 'AtlasTextarea';
var AtlasTextarea$1 = AtlasTextarea;

export { AtlasTextarea$1 as default };
